import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Order, OrderTracking } from '@api/order/order.models';
import { selectOrderNumber, selectOrderStatus } from '@pages/order-status/store/order-status.selectors';

@Component({
    selector: 'order-status-detail',
    templateUrl: './order-status-detail.component.html',
})
export class OrderStatusDetailComponent {
    public orderNumber$ = this.store.select(selectOrderNumber);

    public orderStatus$: Observable<Order | OrderTracking> = this.store.select(selectOrderStatus);

    constructor(
        private readonly store: Store,
    ) {}
}
